<button
  type="button"
  [disabled]="disabled()"
  [ngStyle]="buttonStyles()"
  (click)="buttonClick.emit()"
  class="group relative inline-flex items-center justify-center gap-2 min-w-10 h-10 overflow-hidden rounded-xl border border-transparent p-2.5 transition-all duration-200 ease-in-out bg-(--btn-bg) text-(--btn-text) hover:bg-(--btn-hover-bg) hover:text-(--btn-hover-text) disabled:cursor-not-allowed disabled:opacity-50"
>
  <div
    class="pointer-events-none absolute inset-0 rounded-xl opacity-25 transition-opacity duration-200 group-hover:opacity-100"
    style="
      background: var(--color-gradient-primary-500);
      padding: 1px;
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask-composite: exclude;
      -webkit-mask-composite: destination-out;
    "
  ></div>

  @if (icon() !== iconsEnum.NONE) {
    <bevvi-icon [icon]="icon()" [size]="iconSize.XS" />
  }

  @if (contentType() !== actionButtonContent.ICON) {
    <span class="relative text-label">{{ label() }}</span>
  }
</button>
